<template>
  <div class="componentsCtn_1">
    <div class="top">
      <span v-if="exhibitLevel==1">我的团队</span>
      <span v-if="exhibitLevel==2">
          <span @click="exhibitLevel=1" style="color:rgba(0,0,0,0.6);cursor:pointer;">我的团队/</span>
          <span>{{recentTeamName}}</span>
        </span>
    </div>
    <div v-if="exhibitLevel==1" class="signUp_content">
      <div class="componentCtn-main">
        <div class="projectCtn">
          <div class="topCtn"
               @click="clickPlusIcon()"
               title="新建团队"
               style="background: #D8D8D8;border:none;display: flex;justify-content: center;align-items: center">
            <img src="../../assets/userCenter/我的项目-增加按钮.png" height="93" width="93"/>
          </div>

          <div class="bottomCtn">
          </div>
        </div>

        <div v-for="item in teamList" :key="item.id" class="projectCtn">
          <div @click="clickProject(item.id,item.name)" class="topCtn">
            <!--标识-->
            <a-tag v-if="item.groupRoleType=='创建人'"
                   style="position:absolute;top:9px;right: 3px;" color="green">
              创建者
            </a-tag>
            <!--标识-->
            <a-tag v-else-if="item.groupRoleType=='队长'" style="position:absolute;top:9px;right: 3px;" color="blue">
              队长
            </a-tag>
            <!--标识-->
            <a-tag v-else-if="item.groupRoleType=='队员'" style="position:absolute;top:9px;right: 3px;" color="gray">
              普通队员
            </a-tag>
          </div>
          <div class="middleCtn" :title="item.name">
            {{item.name}}
          </div>
        </div>

      </div>
    </div>
    <!--我的团队二级页面-->
    <span class="myTask">
        <!--选择框-->
        <div v-if="exhibitLevel==2" class="selectPanel">
         <div style="float:right;width: 400px;height:30px;text-align:right;padding-right:20px;">
           <a-checkbox-group v-model="selectedList" :options="satatusOptions" @change="selectChange">
           </a-checkbox-group>
        </div>
        </div>
      <!--用户查询与用户列表-->
        <div v-if="exhibitLevel==2" class="signUp_content">
        <div class="componentCtn-main">
          <div class="searchPanel" >
            <div class="txt" style="width:70px;">
              用户ID:
            </div>
            <div class="input" style="padding-right: 20px;">
              <a-input v-model="JL1Account" size="large" style="height: 40px;font-size: 14px;" placeholder="请输入用户ID"/>
            </div>
            <div class="txt">
              真实姓名:
            </div>
            <div class="input">
              <a-input v-model="name" size="large" style="height: 40px;font-size: 14px;" placeholder="请输入真实姓名"/>
            </div>
            <img @click="getMembersList()" title="搜索"
                  src="../../assets/userCenter/查找.png" height="40" width="40"
                 style="margin-left: 25px;cursor: pointer;"/>
            <img @click="resetSearch()" title="重置"
                 src="../../assets/userCenter/重置.png" height="40" width="40"
                 style="margin-left: 25px;cursor: pointer;"/>
            <img @click="clickAddTeamer()" v-if="currentUserRole==1||currentUserIfCreater==1" title="添加队员"
                 src="../../assets/userCenter/添加任务.png" height="40" width="40"
                 style="margin-left: 25px;cursor: pointer;"/>
          </div>
          <div class="tableCtn">
            <a-table :columns="tableColumns" :data-source="tableData" style="font-weight: 700"
            @change="teamListChange()" :pagination="ipagination">
                <span slot="roleTags" slot-scope="role">
                  <a-tag
                      :color="role === '1' ? 'green' : 'blue' "
                  >
                    <span v-if="role==1">
                      队长
                    </span>
                    <span v-if="role==2">
                      队员
                    </span>
                  </a-tag>
                </span>
                <span slot="statusTags" slot-scope="status">
                    <span v-if="status==0">
                      待确认
                    </span>
                    <span v-if="status==1">
                      已加入
                    </span>
                    <span v-if="status==2">
                      未加入
                    </span>
                </span>
                <span slot="action" slot-scope="text, record">
                  <!--普通用户-->
                 <span v-if="currentUserRole==2&&currentUserIfCreater==0">
                   --
                 </span>
                  <!--是队长但不是创建者-->
                  <span v-else-if="currentUserRole==1&&currentUserIfCreater==0">
                    <!--可以删除非创建者的普通队员-->
                    <a   v-if="record.createStatus==0&&record.status==1" @click="clickDeleteUser(record)"
                        class="ant-dropdown-link" style="color:rgb(241,30,30)">删除</a>
                  </span>
                  <!--是创建者-->
                  <span v-else-if="currentUserIfCreater==1">
                    <!--可以把普通队员设为队长-->
                    <a v-if="record.role==2&&record.status==1" @click="setTeamLeader(record)">设为队长</a>
                    <a-divider v-if="record.role==2&&record.status==1&&record.createStatus!=1" type="vertical"/>
                    <!--可以把删除普通队员-->
                    <a v-if="record.role==2&&record.status==1&&record.createStatus!=1" @click="clickDeleteUser(record)"
                      class="ant-dropdown-link" style="color:rgb(241,30,30)">删除</a>
                  </span>

                </span>
            </a-table>
          </div>

        </div>
      </div>
      <!--任务详情对话框，我的任务-协同标注-->
        <a-modal v-model="projectDetailDialog"
                 :footer="null"
                 centered
                 width="667">
        <div style="width:667px;height:auto;min-height:200px;" class="detailCtn">
          <table class="table1">
            <tr class="tr1">
              <td class="td1" colspan="2">
                <span class="blod">
                  任务名称:
                </span>
                12312312312312312312312312312321
              </td>
            </tr>
            <tr class="tr1">
              <td class="td1">
                <span class="blod">
                  矢量来源:
                </span>
                123
              </td>
              <td class="td1">
                <span class="blod">
                  矢量类型:
                </span>
                123
              </td>
              <td class="td1">
                <span class="blod">
                  坐标系:
                </span>
                123
              </td>
            </tr>
            <tr class="tr1">
              <td class="td1">
                <span class="blod">
                  创建人:
                </span>
                123
              </td>
              <td class="td1">
                <span class="blod">
                  创建时间:
                </span>
                123
              </td>
              <td class="td1">
                <span class="blod">
                  任务状态:
                </span>
                123
              </td>
            </tr>
            <tr class="tr1">
              <td class="td1" colspan="3">
                <span class="blod">
                  任务标签:
                </span>
                <a-tag
                    :color="'blue'"
                >
                  123
                </a-tag>
              </td>

            </tr>
            <tr class="tr1">
              <td class="td1" colspan="3">
                <span class="blod">
                  标注人员:
                </span>
                <a-tag
                    :color="'red'"
                >
                  123
                </a-tag>
              </td>
            </tr>
            <tr class="tr1">
              <td class="td1" colspan="3">
                <span class="blod">
                  影像服务:
                </span>
                <a-tag
                    :color="'green'"
                >
                  123
                </a-tag>
              </td>
            </tr>

            <tr class="tr1">
              <td class="td1">
                <span class="blod">
                  标注总数:
                </span>
                <a-tag
                    :color="'blue'"
                >
                  123
                </a-tag>
              </td>
              <td class="td1">
                <span class="blod">
                  审核通过数量:
                </span>
                <a-tag
                    :color="'green'"
                >
                  123
                </a-tag>
              </td>
              <td class="td1">
                <span class="blod">
                  待审核数量:
                </span>
                <a-tag
                    :color="'red'"
                >
                  123
                </a-tag>
              </td>
            </tr>
          </table>
        </div>
        <template slot="title" style="border:none;">
          <div
              style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
            详情
          </div>
        </template>
      </a-modal>
    </span>
    <!--创建团队对话框-->
    <a-modal v-model="createTeamModal"
             centered
             width="667">
      <template slot="title" style="border:none;">
        <div
            style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
          创建团队
        </div>
      </template>
      <div style="width:667px;height:auto;min-height:100px;">
        <div class="createProjectLine">
          <div class="item-name">
            团队名称
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-input v-model="createTeamName" size="large" style="height: 40px;font-size: 14px;" placeholder="请填写团队名称"/>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            队长
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input" style="width:400px">
            <a-input-search size="large" style="height: 40px;font-size: 14px;" placeholder="请输入队长ID或电话查询" enter-button @search="searchUser"/>
          </div>
          <div class="item-input" style="width:200px;line-height: 40px;padding-left: 17px;">
            <a-radio-group v-model="teamleaderSearchType" buttonStyle="solid">
              <a-radio-button value="phone">
                电话查询
              </a-radio-button>
              <a-radio-button value="id">
                ID查询
              </a-radio-button>
            </a-radio-group>
          </div>

        </div>
        <div v-if="teamLeaderInfo" class="createProjectLine" >
          <div class="item-name">
            队长信息
          </div>
          <div  class="item-input" style="line-height: 40px;border:solid 1px #dcdcdc;border-radius: 5px;padding-left: 12px;">
            {{teamLeaderInfo}}
          </div>
        </div>
      </div>
      <template slot="footer">
        <a-button @click="createTeam()" type="primary">
          创建
        </a-button>
        <a-button @click="createProjectModal=false">
          取消
        </a-button>
      </template>
    </a-modal>
    <!--添加成员对话框-->
    <a-modal v-model="addTeamerModal"
             centered
             width="667">
      <template slot="title" style="border:none;">
        <div
            style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
          添加成员
        </div>
      </template>
      <div style="width:667px;height:auto;min-height:50px;">
        <div class="createProjectLine">
          <div class="item-name">
            成员搜索
          </div>
          <div class="item-input" style="width:400px">
            <a-input-search v-model="memberInputSearch" size="large" style="height: 40px;font-size: 14px;" placeholder="请输入成员ID或电话查询" enter-button @search="searchTeamer"/>
          </div>
          <div class="item-input" style="width:200px;line-height: 40px;padding-left: 17px;">
            <a-radio-group v-model="teamerSearchType" buttonStyle="solid">
              <a-radio-button value="phone">
                电话查询
              </a-radio-button>
              <a-radio-button value="id">
                ID查询
              </a-radio-button>
            </a-radio-group>
          </div>

        </div>
        <div v-if="addteamerInfo" class="createProjectLine" >
          <div class="item-name">
            队员信息
          </div>
          <div  class="item-input" style="line-height: 40px;border:solid 1px #dcdcdc;border-radius: 5px;padding-left: 12px;">
            {{addteamerInfo}}
          </div>
        </div>
      </div>
      <template slot="footer">
        <a-button @click="addTeamer()" type="primary">
          添加
        </a-button>
        <a-button @click="addTeamerModal=false">
          取消
        </a-button>
      </template>
    </a-modal>
    <!--删除矢量对话框-->
    <a-modal v-model="deleteUserModal"
             centered
             width="590"
             title="成员删除确认"
    >
      <div style="width:590px;height:70px;margin-top: 20px;padding-left: 60px;">
        <div style="float:left;width:63px;height: 63px;">
          <img src="../../assets/userCenter/我的项目-注意.png" height="63" width="63"/>
        </div>
        <div style="float:left;width: calc(100% - 63px);height:63px;line-height: 63px;padding-left: 20px;font-size:20px;">
          确定删除此成员？
        </div>
      </div>
      <template slot="footer">
        <a-button @click="confirmDeleteTeamer()" type="primary">
          确定
        </a-button>
        <a-button @click="deleteUserModal=false">
          取消
        </a-button>
      </template>
    </a-modal>



  </div>
</template>

<script>
import moment from 'moment';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';

export default {
  name: "SignUp",
  data() {
    return {
      dataList: [],
      createTeamModal: false,//创建项目
      exhibitLevel: 1,//展现层级
      //以下为任务字段
      tableColumns: [
        {
          title: '用户ID',
          dataIndex: 'jl1Account',
          key: 'jl1Account',
          align: 'center'
        },
        {
          title: '真实姓名',
          dataIndex: 'name',
          key: 'name',
          align: 'center'

        },
        {
          title: '联系方式',
          dataIndex: 'phone',
          key: 'phone',
          align: 'center'
        },
        {
          title: '单位/机构',
          key: 'company',
          dataIndex: 'company',
          align: 'center'
        },
        {
          title: '团队角色',
          dataIndex: 'role',
          key: 'role',
          scopedSlots: {customRender: 'roleTags'},
          align: 'center'

        },
        {
          title: '状态',
          key: 'status',
          dataIndex: 'status',
          scopedSlots: {customRender: 'statusTags'},
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: {customRender: 'action'},
          align: 'center'

        },
      ],
      tableData: [
      ],
      projectDetailDialog: false,//任务详情
      selectedList:['已加入','待确认','未加入'],
      satatusOptions:['已加入','待确认','未加入'],
      //以下创建团队字段
      memberInputSearch:'',
      teamleaderSearchType:'phone',
      teamLeaderInfo:"",
      createTeamName:"",
      createTeamLeaderId:"",
      teamList:[],
      //我的团队二级页面
      recentTeamId:'',
      JL1Account:'',
      name:'',
      status:[0,1,2],
      pageSize:10,
      pageNo:1,
      currentUserRole:2,//用户角色，1队长，2队员
      currentUserIfCreater:0,//0不是创建者，1是创建者
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        // showQuickJumper: true,
        // showSizeChanger: true,
        total: 0,
      },
      //添加成员
      addTeamerModal:false,
      addteamerInfo:"",
      addTeamerId:'',
      teamerSearchType:'phone',
      //删除成员
      deleteUserModal:false,
      deleteUserId:'',
    }
  },
  methods: {
    getKey() {
      return localStorage.getItem("token");
    },
    //设为队长
    setTeamLeader:function (data) {
      console.log(data)
      let param=new FormData();
      param.append('groupId',this.recentTeamId)
      param.append('jl1UserId',data.jl1Account)
      this.axios.post("/tilesapi/tiles/member/editGroupUserRole",param,{
        headers:{
          Authorization:'Bearer ' + this.getKey(),
        }
      }).then((response)=>{
        console.log('设为队长')
        console.log(response)
        if(response.data.code==200){
          this.$message.success(response.data.msg)
        }
        if(response.data.code==500){
          this.$message.error(response.data.msg)
        }
        this.getMembersList();


      })

    },
    //查看当前用户角色
    getCurrentUserRole:function () {
      let param=new FormData();
      param.append('groupId',this.recentTeamId)
      this.axios.post("/tilesapi/tiles/member/queryGroupUserRole",param,{
        headers:{
          Authorization:'Bearer ' + this.getKey(),
        }
      }).then((response)=>{
        console.log('用户角色')
        console.log(response)
        this.currentUserRole=response.data.data.role;
        this.currentUserIfCreater=response.data.data.createStatus;


      })
    },
    //确认删除成员
    confirmDeleteTeamer:function () {
      let param=new FormData();
      param.append('groupId',this.recentTeamId)
      param.append('jl1UserId',this.deleteUserId)
      this.axios.post("/tilesapi/tiles/member/deleteGroupUser",param,{
        headers:{
          Authorization:'Bearer ' + this.getKey(),
        }
      }).then((response)=>{
        console.log('删除队员')
        console.log(response)
        if(response.data.code==200){
          this.$message.success(response.data.msg)
          this.deleteUserModal=false;

        }
        if(response.data.code==500){
          this.$message.error(response.data.msg)
        }
        this.getMembersList();


      })
    },
    //点击删除成员
    clickDeleteUser:function (data) {
      console.log(data)
      this.deleteUserModal=true;
      this.deleteUserId=data.jl1Account;
    },
    //点击添加团队成员
    clickAddTeamer:function () {
      this.addTeamerModal=true;
      this.addteamerInfo="";
      this.addTeamerId=""
    },
    //确定添加成员
    addTeamer:function(){
      if(!this.addTeamerId){
        this.$message.error('先搜索成员！');
        return;
      }
      let param={
        "groupId":this.recentTeamId,
        "jl1AccountList":[this.addTeamerId]
      }
      this.axios.post("/tilesapi/tiles/member/addMember",param,{
        headers:{
          Authorization:'Bearer ' + this.getKey(),
        }
      }).then((response)=>{
        console.log('添加成员')
        console.log(response)
        if(response.data.code=='200'){
          this.$message.success('添加成功')
          this.addTeamerModal=false;
          this.memberInputSearch='';
          this.getMembersList();
        }else {
          this.$message.error(response.data.msg)
        }
      })
    },
    //点击某个团队，一级页面
    clickProject: function (id,name) {
      console.log('团队id')
      console.log(id)
      this.recentTeamId=id;
      this.recentTeamName=name;
      this.getMembersList();
      this.getCurrentUserRole();
      this.exhibitLevel = 2;

    },
    resetSearch: function () {
      this.name = '';
      this.JL1Account = '';
      this.selectedList=['已加入','待确认','未加入'];
      this.status=[0,1,2];
      this.getMembersList();
    },
    getSignUpData: function () {
      let that = this
      this.axios
          .get("/loginapi/getLoginInfo", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('用户信息')
        console.log(response)
        if (response.status == 200) {
          that.dataList = response.data.data;
        }
      })
    },

    disabledDate(current) {
      console.log("时间日期选择器")
      console.log(current)
      // Can not select days before today and today
      return current && current < moment().subtract(1, 'day').endOf('day');
    },
    //点击新建项目图表
    clickPlusIcon:function (){
      this.createTeamModal=true;
      this.teamLeaderInfo="";
      this.createTeamLeaderId="";
    },
    //成员列表变化
    teamListChange:function (pagination, filters, sorter){
      console.log(pagination)
      console.log(filters)
      console.log(sorter)
      this.ipagination.current=pagination.current;
      this.ipagination.pageSize=pagination.pageSize;
      this.getMembersList();
    },
    //多选框改变
    selectChange:function (data){
      console.log(data)
      this.status=[];
      if(data.indexOf('待确认')>-1){
        console.log('待确认')
        this.status.push(0)
      }
      if(data.indexOf('已加入')>-1){
        this.status.push(1)
      }
      if(data.indexOf('未加入')>-1){
        this.status.push(2)
      }
      console.log(this.status)
      this.getMembersList();
    },
    //根据电话与ID查询用户
    searchUser:function (data){
      console.log(data)
      let param=new FormData();
      if(this.teamleaderSearchType=='id'){
        param.append('JL1Account',data);
        param.append('phone',"");
      }else if(this.teamleaderSearchType=='phone'){
        param.append('JL1Account',"");
        param.append('phone',data)
      }
      this.axios.post("/tilesapi/queryUserByPhoneAndAccount",param,{
        headers:{
          Authorization:'Bearer ' + this.getKey(),
        }
      }).then((response)=>{
        console.log(response)
        if(response.data.data){
          this.teamLeaderInfo=response.data.data.account;
          this.createTeamLeaderId=response.data.data.jl1Account;
        }
        else {
          this.$message.error("无此用户")
        }
      })
    },
    //根据电话与ID查询用户，添加成员
    searchTeamer:function (data) {
      let param=new FormData();
      if(this.teamerSearchType=='id'){
        param.append('JL1Account',data);
        param.append('phone',"");
      }else if(this.teamerSearchType=='phone'){
        param.append('JL1Account',"");
        param.append('phone',data)
      }
      this.axios.post("/tilesapi/queryUserByPhoneAndAccount",param,{
        headers:{
          Authorization:'Bearer ' + this.getKey(),
        }
      }).then((response)=>{
        console.log(response)
        if(response.data.data){
          this.addteamerInfo=response.data.data.account;
          this.addTeamerId=response.data.data.jl1Account;
        }
        else {
          this.$message.error("无此用户")
        }
      })
    },
    //创建团队
    createTeam:function () {
      if (!this.createTeamName) {
        this.$message.error("请输入团名");
        return;
      } else if (!this.createTeamLeaderId) {
        this.$message.error("请选择队长");
        return;
      }

      let param = {
        "name": this.createTeamName,
        "groupLeaderUserId": this.createTeamLeaderId,
      }
      this.axios.post("/tilesapi/tiles/group/addGroupWithMember",param, {
        headers: {
          Authorization: 'Bearer ' + this.getKey(),
        }
      }).then((response) => {
        console.log(response)
        if(response.data.code==200){
          this.$message.success('创建成功!');
          this.createTeamModal=false;
          this.getTeamList();
        }
        else {
          this.$message.error(response.data.msg);
        }
      })
    },
    //查询团队列表
    getTeamList:function (){
      this.axios.post("/tilesapi/tiles/group/list",null, {
        headers: {
          Authorization: 'Bearer ' + this.getKey(),
        }
      }).then((response) => {
        console.log("获取团队列表")
        console.log(response)
        this.teamList=response.data.data;
      })
    },
    //获取团队成员列表
    getMembersList:function (){
      let param=new FormData();
      param.append('JL1Account',this.JL1Account);
      param.append('name',this.name);
      param.append('status',this.status);
      param.append('groupId',this.recentTeamId);
      param.append('pageSize',this.ipagination.pageSize);
      param.append('pageNo',this.ipagination.current);
      this.axios
          .post("/tilesapi/tiles/member/list", param,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('获取团队成员')
        console.log(response)
        this.tableData=response.data.data.records;
        this.ipagination.total=response.data.total;
      })
    }

  },
  mounted() {
    this.getSignUpData();
    this.getTeamList();

  }
}
</script>

<style scoped lang="scss">
.myTask {
  .detailCtn {
    .table1 {
      width: 667px;

      .tr1 {
        height: 40px;
        line-height: 40px;
        width: 100%;
      }

      .td1 {
        width: 200px;
      }

      .blod {
        font-weight: bold;
      }
    }
  }

  ::v-deep .ant-table-thead > tr > th {
    font-weight: 700;
  }

  .tableCtn {
    width: 100%;
    height: 500px;
    padding-right: 20px;
  }

  .searchPanel {
    width: 100%;
    height: 60px;
    position: relative;
    display: flex;
    justify-content: left;
    padding-top: 10px;

    .txt {
      width: 85px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
    }

    .input {
      width: 200px;
      height: 40px;
      line-height: 40px;
    }
  }

  .bash_iframe {
    width: calc(100% - 20px);
  }

  .signUp_content {
    width: 100%;
    height: 100%;
    overflow-y: auto;

    .componentCtn-main {
      position: relative;
      width: 100%;
      height: auto;
      min-height: 570px;
      display: flex;
      justify-content: left;
      flex-flow: wrap;
    }

    .componentCtn-main-fullScreen {
      position: fixed;
      top: 0px;
      left: 0px;
      width: 100vw;
      height: 100%;
      z-index: 10000;
    }
  }

  /*滚动条样式*/
  .signUp_content::-webkit-scrollbar {
    width: 4px;
  }

  .signUp_content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .signUp_content::-webkit-scrollbar-track {
  }

  .selectPanel {
    height: 30px;
    line-height: 30px;
    width: 100%;
    position: relative;
  }

  .top {
    height: 84px;
    line-height: 84px;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
  }

  .componentsCtn_1 {
    width: 100%;
    min-height: 660px;
    height: auto;
    background: #F5F5F6;
    border-radius: 16px;
    padding-left: 35px;
  }
}

::v-deep .ant-calendar-range-picker-input {
  text-align: left;
}

::v-deep .ant-input-lg {
  font-size: 14px;
}

.createProjectLine {
  display: flex;
  justify-content: left;
  width: 100%;
  height: auto;
  min-height: 40px;
  margin-bottom: 20px;

  .item-name {
    position: relative;
    width: 90px;
    height: 40px;
    text-align: left;
    line-height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
  }

  .item-input {
    width: 560px;
    min-height: 40px;
    height: auto;
  }
}

.lineClamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.projectCtn {
  width: 232px;
  height: 258px;
  border-radius: 16px;
  border: 1px solid #979797;
  margin-right: 32px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .topCtn {
    position: relative;
    margin-top: 6px;
    width: 220px;
    height: 189px;
    border-radius: 16px;
    border: 1px solid #979797;
    background-image: url("~@/assets/userCenter/我的团队-背景图.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    .contentMask {
      display: none;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 16px;
      top: 0px;
      left: 0px;
      .contentItem {
        width: 100%;
        height: 20px;
        line-height: 20px;
        padding-left: 15px;
        padding-right: 10px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }

  .topCtn:hover .contentMask {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: rgba(0, 0, 0, 0.6);
  }

  .middleCtn {
    margin-top: 8px;
    padding-left: 15px;
    padding-right: 15px;
    width: 213px;
    height: 50px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1E81EB;
    line-height: 50px;
    text-align: center;
    background: linear-gradient(108deg, #1E81EB 0%, #AE48FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .bottomCtn {
    width: 100%;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;

    .bottomImg {
      display: block;
      margin-right: 16px;
      cursor: pointer;
    }
  }
}

.signUp_item_banner {
  width: 1032px;
  height: 122px;
  background: #F7F7F7;
  border-radius: 16px;
  margin-bottom: 20px;
  padding-top: 31px;
  padding-left: 39px;
}

.signUp_content {
  width: 100%;
  height: 576px;
  overflow-y: auto;

  .componentCtn-main {
    width: 100%;
    height: auto;
    min-height: 570px;
    display: flex;
    justify-content: left;
    flex-flow: wrap;
  }
}

/*滚动条样式*/
.signUp_content::-webkit-scrollbar {
  width: 4px;
}

.signUp_content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.signUp_content::-webkit-scrollbar-track {
}

.top {
  height: 84px;
  line-height: 84px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
}

.componentsCtn_1 {
  width: 100%;
  height: 660px;
  background: #F5F5F6;
  border-radius: 16px;
  padding-left: 35px;
}

</style>